import { Flex, Typography } from 'antd';

import logo from 'assets/images/logo/logo-adv-short.svg';
import { Balance } from 'entities/User';
import { EMainRoutes } from 'shared/typings';
import { ButtonStyleLink, Logo } from 'shared/ui';
import { HeaderMenu } from 'widgets/Header';
import { useHeader } from 'widgets/Header/hooks/useHeader';

import { Notifications } from '../Notifications/Notifications';
import { UserInfo } from '../UserInfo/UserInfo';

import styles from './Header.module.scss';

export const HeaderAdvertiser = () => {
	const { isDesktop, isMobile, headerTitle, t } = useHeader();

	return (
		<Flex className={styles.header} gap={8} justify={'space-between'} align={'center'}>
			{isDesktop ? (
				<Typography.Title style={{ margin: 0 }} type="secondary" level={4}>
					{headerTitle}
				</Typography.Title>
			) : (
				<Logo image={logo} />
			)}
			<Flex align="center" gap="8px">
				{!isMobile && <Balance />}
				{isDesktop && (
					<ButtonStyleLink to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.OFFER}/${EMainRoutes.CREATE}`} type="primary">
						{t('Create Offer')}
					</ButtonStyleLink>
				)}
				<Notifications />
				<UserInfo />
				{!isDesktop && <HeaderMenu />}
			</Flex>
		</Flex>
	);
};
